(function () {
  /**
   * @ngdoc module
   * @name binky.core.log
   * @description defines log utilities
   */
  angular.module('binky.core.log', ['binky.core.common.analytics', 'binky.core.lodash']);
})();
